import {
  ResponseData,
  TBrandLogoInfo,
  TCreatorRecentInfo,
  THomeBannerInfo,
  THomeProductResponse,
  TProductInfo,
  TProductResponse,
  TRankProductInfo,
  TSearchConfigResponse,
  TSettingResponse,
  THomeOverviewResponse,
  THomeAdInfoResponse,
} from "@/typings";
import { fetchYooFindsApi } from "@/utils/fetch";
import {
  GetHomeProductRecommendParams,
  GetProductRecommendParams,
  GetProductSearchParams,
  GetHomeRankingProductParams,
  GetHomeAdvParams,
  GetHomeAdInfoParams,
  GetHomeProductRecommendV3Params,
  GetHomeBannerArgs,
} from "./interface";
import { omit } from "lodash";
import { getUri } from "@/utils/url";

export async function fetchHomeAdInfo(params: GetHomeAdInfoParams = {}) {
  return await fetchYooFindsApi<ResponseData<THomeAdInfoResponse>>(
    getUri(`api/adv/adInfo`, params),
    {
      cache: "no-store",
    }
  );
}

export async function fetchHomeAdv(params: GetHomeAdvParams = {}) {
  return await fetchYooFindsApi<ResponseData<THomeBannerInfo[]>>(
    getUri(`api/adv/quick-button`, params)
  );
}

export async function fetchHomeOverview() {
  return await fetchYooFindsApi<ResponseData<THomeOverviewResponse>>(
    "api/home/index/overview"
  );
}

export async function fetchHomeRankingProduct(
  params: GetHomeRankingProductParams
) {
  return await fetchYooFindsApi<ResponseData<TProductInfo[]>>(
    getUri(`api/rank/product/soldTop`, params)
  );
}

export async function fetchHomeProductRecommend(
  params: GetHomeProductRecommendParams
) {
  return await fetchYooFindsApi<ResponseData<THomeProductResponse>>(
    getUri(
      `api/v2/products/recommend/${params.recommendType}`,
      omit(params, "recommendType")
    )
  );
}

export async function fetchHomeProductRecommendV3(
  params: GetHomeProductRecommendV3Params
) {
  return await fetchYooFindsApi<ResponseData<THomeProductResponse>>(
    getUri(`api/v3/products/recommend`, params)
  );
}

export async function fetchSetting() {
  return await fetchYooFindsApi<ResponseData<TSettingResponse>>("api/setting");
}

export async function fetchHomeBanner({ params, headers }: GetHomeBannerArgs) {
  return await fetchYooFindsApi<ResponseData<THomeBannerInfo[]>>(
    getUri("api/adv/home-banner", params || {}),
    {
      cache: "no-store",
      headers,
    }
  );
}

export async function fetchSearchConfig() {
  return await fetchYooFindsApi<ResponseData<TSearchConfigResponse>>(
    "api/search/config"
  );
}

export async function fetchProductSearch(params: GetProductSearchParams) {
  return await fetchYooFindsApi<ResponseData<TProductResponse>>(
    "api/searchV3",
    {
      method: "POST",
      body: JSON.stringify(params),
    }
  );
}

export async function fetchProductRecommend(params: GetProductRecommendParams) {
  return await fetchYooFindsApi<ResponseData<TProductResponse>>(
    `api/v2/products/recommend/${params.recommendType}/list`,
    {
      method: "POST",
      body: JSON.stringify(omit(params, "recommendType")),
    }
  );
}

export async function fetchRankProduct() {
  return await fetchYooFindsApi<ResponseData<TRankProductInfo[]>>(
    "api/ranking/products/index"
  );
}

export async function fetchBrandLogoList() {
  return await fetchYooFindsApi<ResponseData<TBrandLogoInfo[]>>(
    "api/brand/logoList"
  );
}

export async function fetchBonusIndex() {
  return await fetchYooFindsApi<ResponseData<TProductResponse>>(
    "api/bonus/index"
  );
}

export async function fetchFreeShipping() {
  return await fetchYooFindsApi<ResponseData<TProductResponse>>(
    "api/freeshipping"
  );
}

export async function fetchCreatorRecent() {
  return await fetchYooFindsApi<ResponseData<TCreatorRecentInfo[]>>(
    "api/black/creator/recent"
  );
}
